// extracted by mini-css-extract-plugin
export default {"statucBlock":"Success_statucBlock__vc-rd","paymentInfo":"Success_paymentInfo__kEIah","infoBlock":"Success_infoBlock__CRgWN"};